import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';

export const isIosDevice = () => {
  return typeof window !== 'undefined' &&
  window.navigator &&
  window.navigator.platform &&
  (/iP(ad|hone|od)/.test(window.navigator.platform) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1));
}

export const viewportUnits = () => {
  const heightHandler = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  heightHandler()
  window.addEventListener('resize', () => {
    heightHandler()
  });
}

export const disableScroll = ( el ) => {
  window.latestScrollY = window.latestScrollY || window.scrollY
  document.body.dataset.modals = ++document.body.dataset.modals || 1
  disableBodyScroll(el)
  if(document.body.dataset.modals == 1){
    window.requestAnimationFrame(() => {
      if(isIosDevice()) document.body.style.setProperty("top", `${window.latestScrollY * -1}px`)
    })
  }
}

export const enableScroll = (el) => {
  document.body.dataset.modals = --document.body.dataset.modals || 0
  enableBodyScroll(el)
  if(document.body.dataset.modals == 0){
    clearAllBodyScrollLocks()
    window.requestAnimationFrame(() => {
      if(isIosDevice()){
        document.body.style.setProperty("top", "")
        document.body.scrollTo(0, window.latestScrollY)
      }
      window.latestScrollY = null
    })
  }
}

export const isTouchDevice = () => {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}